import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const defaultMetaTitle = "Time Cloud Safe on Site";

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      title: defaultMetaTitle
    }
  },
  {
    path: "/:id",
    name: "signin",
    params: {
      skipScreen: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      title: defaultMetaTitle + " - Sign In"
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SignIn.vue")
  },
  {
    path: "/:id/visiting",
    name: "visiting",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      title: defaultMetaTitle + " - Visiting"
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SignIn-Visiting.vue")
  },
  {
    path: "/:id/agree",
    name: "agree",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      title: defaultMetaTitle + " - Agreement"
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SignIn-Agree.vue")
  },
  {
    path: "/:id/signout",
    name: "signout",
    params: {
      checkout: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      title: defaultMetaTitle + " - Sign Out"
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SignOut.vue")
  },
  {
    path: "/:id/signout/success",
    name: "signout-success",
    params: {
      message: ""
    },
    meta: {
      title: defaultMetaTitle + " - Sign Out"
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SignOutSuccess.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  next();
});

export default router;
